import type { ApiSchemas } from '$lib/api/shopwareApi.js';

type IntlFormatterOptions<T> = T & {
    format?: string;
    locale?: string;
};
type NumberFormatter = (d: number, options?: IntlFormatterOptions<Intl.NumberFormatOptions>) => string;

/**
 *
 * @param numberFormatter should be `$number`, the value of the svelte-i18n number store
 * @param storeContext the value from `useStoreContext`
 * @param price the price to format
 */
export function formatCurrency(
    numberFormatter: NumberFormatter,
    storeContext: ApiSchemas['SalesChannelContext'],
    price: number
): string {
    const currencyCode = storeContext.currency?.isoCode ?? 'EUR';

    return numberFormatter(price, {
        style: 'currency',
        currency: currencyCode
    });
}
